import { fetchDataError, fetchFacetsSuccess } from "../reducers";
import getSearchUrl from "./getSearchUrl";

/**
* Filters dienen eerst ingeladen te worden, anders kunnen URL parameters niet gematcht worden om actieve data op te halen
*/

export default function fetchFilters () {
    const reactAppData = window.wpApiSettings || {};
    const { nonce } = reactAppData

    return dispatch => {

		fetch( '/wp-json/typografics/v1/knowledge', {
            credentials: 'include',
            headers: {
                'content-type': 'application/json',
                'X-WP-Nonce': nonce
            }
        } )
            .then( result => result.json() )
            .then( result => {

                if ( result.error ) {
                    throw ( result.error );
                }

                dispatch( fetchFacetsSuccess( result.categories, result.tools ) );
                dispatch( getSearchUrl() )

                return result.filters;
            } )
            .catch( error => {
                dispatch( fetchDataError( error ) );
            } )
    }
}